import React from "react";
import { useDispatch } from "react-redux";

import { USER_TYPE } from "../../constants/common";
import { setUser } from "../../redux/slices/userSlice";
import { getLanguage } from "../../utils/getLanguage";
import { useNavigateWithLang } from "../../utils/navigation";

const RegisterParent = () => {
  const lang = getLanguage();
  const navigate = useNavigateWithLang();
  const dispatch = useDispatch();

  const handleRegisterParent = () => {
    const payload = {
      role: USER_TYPE.PARENT.ROLE,
      name: "New Parent User",
      email: "newparent@example.com",
      access_token: "new-parent-registration-access_token",
    };

    dispatch(setUser(payload));
    navigate(`/register/${USER_TYPE.PARENT.ROLE}`);
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 p-6">
      <h1 className="mb-8 text-3xl font-semibold text-gray-800">Register as Parent</h1>
      <button
        onClick={handleRegisterParent}
        className="w-full rounded-lg bg-yellow-600 px-6 py-3 text-white shadow-md transition duration-300 hover:bg-yellow-700"
        aria-label="Register as Parent"
      >
        Register Now
      </button>
    </div>
  );
};

export default RegisterParent;
